<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OX99gH/Images/Burrowes_RespectforChristmas_ebook_INTERIOR.jpg?1733085642979" alt="This image is the cover for the book Respect for Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Respect for Christmas
      </h1>
      <p class="bookDescription body article font2">
        <b>A former courtesan and a new baron have a most unlikely Christmas in this special novella from the <i>New York Times </i>bestselling author of <i>My One and Only Duke</i>.</b><br/><br/> Previously published in <i>Virtues of Christmas</i>.   Henrietta Whitlow is leaving behind the life of a very successful courtesan in hopes of making peace with her family in the shires. Michael Brenner's family all but ignore him, despite his shiny new baronial title, and his errand along the Oxford road isn't half so benign as Henrietta's. While trying to settle a debt of honor involving Henrietta, Michael instead loses his heart and comes to understand the true meaning of holiday spirit. <br/> "Grace Burrowes is a romance treasure." -- Tessa Dare
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grace Burrowes
      </h2>
      
      <p class="authorDescription body article">Grace Burrowes grew up in central Pennsylvania and is the sixth of seven children. She discovered romance novels in junior high and has been reading them voraciously ever since. Grace has a bachelor's degree in political science, a bachelor of music in music history (both from the Pennsylvania State University), a master's degree in conflict transformation from Eastern Mennonite University, and a juris doctor from the National Law Center at George Washington University. </br></br> Grace is a <I>New York Times</I> and <I>USA Today</I> bestselling author who writes Georgian, Regency, Scottish Victorian, and contemporary romances in both novella and novel lengths. She enjoys giving workshops and speaking at writers' conferences.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?244cb19c